import { object, string } from 'yup'

import { TipoArticuloInputProps } from '../interfaces'

/**
 * Validamos los datos de formulario de la unidad de medida
 * @param input
 */
export const tipoArticuloRegistroValidator = async (
  input: TipoArticuloInputProps,
): Promise<Array<string>> => {
  try {
    const schema = {
      codigo: string().required('Ingrese el Código Tipo Artículo'),
      descripcion: string().required('Ingrese la Descripción'),
      // grupoUnidadMedida: string().required(),
    }
    return []
  } catch (e: any) {
    return [e.message]
  }
}
export const TipoArticuloRegistroValidationSchema = object({
  codigo: string().required('Ingrese el Código Tipo Artículo'),
  descripcion: string().required('Ingrese la Descripción'),
  //grupoUnidadMedida: string().required(),
})
